import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { AuthProvider } from "./shared/context/auth-context";
import { BrowserRouter as Router } from "react-router-dom";
import ReactGA from "react-ga4";

ReactGA.initialize("G-JD0M3H34SV");
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<AuthProvider>
		<Router>
			<App />
		</Router>
	</AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
